import { Directive, HostBinding, Input, OnChanges } from '@angular/core';

@Directive({
  selector: '[sukaInputGroupItem]'
})
export class InputGroupItem implements OnChanges {
  @Input('sukaInputGroupItem') type: 'default' | 'auto' | 'full'  =  'default';

  @HostBinding('class.input-group__item') baseClass = true;
  @HostBinding('class.input-group__item--auto') auto = false;
  @HostBinding('class.input-group__item--full') full = false;

  ngOnChanges() {
    this.auto = this.full = false;

    switch (this.type) {
      case 'auto': this.auto = true; break;
      case 'full': this.full = true; break;
      default: break;
    }
  }
}
